import { __assign, __awaiter, __generator } from "tslib";
import { api } from '../../_core/utils/api-helpers';
import { pmaMarkFulfilled, pmaMarkRejected, pmaResetExistingMark, } from '../../_core/utils/pma-reducer';
import { domainAction, domainSelector } from '../../domain/domain-redux';
import { chatActionType } from '../chat-redux';
import { ARBITRARY_ID_INITIAL_DATA, DOMAIN_TYPE_ARBITRARY } from '../../../consts';
import { appWscInstance } from '../../../_library/utils/app-ws-client';
/**
 * @param identity
 * @param threadId
 * @param optimisticData
 */
export var createThread = function (identity, threadId, optimisticData) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var id, type, rootState, wsc, options, value, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    identity = identity || {};
                    id = threadId;
                    type = chatActionType.FETCH_CREATE_THREAD;
                    rootState = getState();
                    // Join the WS room immediately so /start messages are delivered live and not buffered.
                    try {
                        wsc = appWscInstance();
                        wsc && id && wsc.joinRoom(id);
                    }
                    catch (e) {
                        console.error('WS joinRoom failed', e);
                    }
                    options = {
                        initialData: domainSelector.getInitialData(rootState) || {},
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    dispatch(pmaResetExistingMark(type, id));
                    return [4 /*yield*/, dispatch({
                            type: type,
                            payload: {
                                data: __assign(__assign({}, optimisticData), { id: id }),
                                promise: api().createThread(threadId, identity.api_token, options),
                            },
                        })];
                case 2:
                    value = (_c.sent()).value;
                    dispatch(pmaMarkFulfilled(type, value, id));
                    dispatch(domainAction.mergeModelsPayload(value));
                    // telekom specific feature - remove omniChannelData once used. Reason:
                    // a possible new request for restarting chat should create new chat, not chat with omniChannel Data
                    dispatch(domainAction.mergeModelsPayload((_a = {},
                        _a[DOMAIN_TYPE_ARBITRARY] = (_b = {},
                            _b[ARBITRARY_ID_INITIAL_DATA] = {
                                omniChannelData: null,
                            },
                            _b),
                        _a)));
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    console.error(e_1);
                    dispatch(pmaMarkRejected(type, e_1, threadId));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
